module.exports = __webpack_public_path__ + "img/社区文化.fb9a6d70.png";